// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.translateInputWrapper__WfRpv {
  display: flex;
  align-items: center;
  gap: 30px;
  width: 100%;
}

.leftSideWrapper__xFAty {
  width: 70%;
}
@media (max-width: 900px) {
  .leftSideWrapper__xFAty {
    width: 50%;
  }
}

.rightSideWrapper__WA4xN {
  display: flex;
  align-items: center;
  width: 30%;
}

.actionsBlock__bLnVy {
  display: flex;
  gap: 10px;
}

.separator__TGI5U {
  height: 35px;
  width: 1px;
  background: var(--tables-primary-row-stroke);
}`, "",{"version":3,"sources":["webpack://./../src/pages/ManageTranslations/components/TranslationsInput/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AAzEF;;AA4EA;EACE,UAAA;AAzEF;AA2EE;EAHF;IAII,UAAA;EAxEF;AACF;;AA2EA;EACE,aAAA;EACA,mBAAA;EACA,UAAA;AAxEF;;AA2EA;EACE,aAAA;EACA,SAAA;AAxEF;;AA2EA;EACE,YAAA;EACA,UAAA;EACA,4CAAA;AAxEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.translateInputWrapper {\n  display: flex;\n  align-items: center;\n  gap: 30px;\n  width: 100%;\n}\n\n.leftSideWrapper {\n  width: 70%;\n\n  @media (max-width: 900px) {\n    width: 50%;\n  }\n}\n\n.rightSideWrapper {\n  display: flex;\n  align-items: center;\n  width: 30%;\n}\n\n.actionsBlock {\n  display: flex;\n  gap: 10px;\n}\n\n.separator {\n  height: 35px;\n  width: 1px;\n  background: var(--tables-primary-row-stroke);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"translateInputWrapper": `translateInputWrapper__WfRpv`,
	"leftSideWrapper": `leftSideWrapper__xFAty`,
	"rightSideWrapper": `rightSideWrapper__WA4xN`,
	"actionsBlock": `actionsBlock__bLnVy`,
	"separator": `separator__TGI5U`
};
module.exports = ___CSS_LOADER_EXPORT___;
